// Rozdělení abort bucketů Naja UniqueExtension podle Nette signálu.
//
// Naja standardně drží všechny requesty v jediném bucketu 'default' a každý nový
// request abortuje ten předchozí rozjetý. V praxi si tak navzájem střílely úplně
// nesouvisející věci: autocomplete při psaní zabíjel rozjeté uložení dokladu
// (tiket 854 – "Uložit a zavřít" bez redirectu), setStoreFrom, nebo auto-otevírání
// inline řádku – a vznikaly smyčky showInlineAdd ⇄ cokoliv (viz js-loop.log).
//
// Nové rozdělení (nastavuje se v 'before', tedy dřív, než UniqueExtension v 'start'
// bucket použije):
//   - request se signálem (?do=...)  → bucket 'do:<signál>': stejný signál se dál
//     deduplikuje (nový abortuje starý – přesně to chceme u autocomplete při psaní),
//     ale různé signály si už nepřekáží,
//   - POST bez signálu (submit formuláře) → unique=false: uložení nesmí abortovat
//     nikdo (duplicitní odeslání hlídá DoubleSubmitGuard),
//   - GET bez signálu (navigace) → zůstává 'default': nová navigace starou abortuje.
//
// Explicitní data-naja-unique (např. "off" nebo vlastní bucket) má vždy přednost.
class RequestScopeExtension {
    initialize(naja) {
        naja.addEventListener('before', (event) => {
            const {options, url, method} = event.detail;

            if (options.unique !== undefined && options.unique !== 'default') {
                return;
            }

            const signal = /[?&]do=([^&]+)/.exec(url || '');
            if (signal) {
                options.unique = 'do:' + decodeURIComponent(signal[1]);
            } else if ((method || 'GET').toUpperCase() === 'POST') {
                options.unique = false;
            }
        });

        // Počítadlo rozjetých submitů (unique=false), aby si automatiky typu
        // tryOpenInlineAdd mohly počkat, dokud se ukládá.
        naja.addEventListener('start', (event) => {
            if (event.detail.options.unique === false) {
                pendingSubmits++;
            }
        });
        naja.addEventListener('complete', (event) => {
            if (event.detail.options.unique === false) {
                pendingSubmits = Math.max(0, pendingSubmits - 1);
            }
        });
    }
}

let pendingSubmits = 0;

// Běží právě teď nějaký submit formuláře (POST bez signálu / data-naja-unique="off")?
export function hasPendingSubmit() {
    return pendingSubmits > 0;
}

export default RequestScopeExtension;
